export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';
export const CLEAR_AUTH_FEEDBACK = 'CLEAR_AUTH_FEEDBACK';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_ACTIVE_PID = 'SET_ACTIVE_PID';

export const normalizeAuthPayload = (payload = {}) => {
  const expiresIn = Number(payload.expires_in) || 900;
  return {
    token: payload.access_token || payload.token || '',
    refreshToken: payload.refresh_token || payload.refreshToken || '',
    expiresAt: Date.now() + expiresIn * 1000,
    tokenType: payload.token_type || 'Bearer',
    user: payload.user || {},
    pid: payload.pid || '',
    products: payload.products || [],
    productsTotal: payload.productsTotal || 0,
    productRole: payload.productRole || '',
    productName: payload.productName || '',
  };
};

export const getBearerToken = (token) => {
  if (!token) return '';
  return token.startsWith('Bearer ') ? token : `Bearer ${token}`;
};

export const loginUser = (user, history) => ({
  type: LOGIN_USER,
  payload: { user, history },
});
export const loginUserSuccess = (user) => ({
  type: LOGIN_USER_SUCCESS,
  payload: user,
});
export const loginUserError = (message) => ({
  type: LOGIN_USER_ERROR,
  payload: { message },
});

export const refreshTokenSuccess = (payload) => ({
  type: REFRESH_TOKEN_SUCCESS,
  payload,
});

export const setProducts = (products, productsTotal) => ({
  type: SET_PRODUCTS,
  payload: {
    products: products || [],
    productsTotal:
      typeof productsTotal === 'number'
        ? productsTotal
        : (products || []).length,
  },
});

export const setActivePid = (pid, productRole = '', productName = '') => ({
  type: SET_ACTIVE_PID,
  payload: { pid, productRole, productName },
});

export const forgotPassword = (forgotUserMail, history) => ({
  type: FORGOT_PASSWORD,
  payload: { forgotUserMail, history },
});
export const forgotPasswordSuccess = () => ({
  type: FORGOT_PASSWORD_SUCCESS,
});
export const forgotPasswordError = (message) => ({
  type: FORGOT_PASSWORD_ERROR,
  payload: { message },
});

export const resetPassword = ({ token, newPassword, history }) => ({
  type: RESET_PASSWORD,
  payload: { token, newPassword, history },
});
export const resetPasswordSuccess = () => ({
  type: RESET_PASSWORD_SUCCESS,
});
export const resetPasswordError = (message) => ({
  type: RESET_PASSWORD_ERROR,
  payload: { message },
});

export const changePassword = ({ currentPassword, newPassword, history }) => ({
  type: CHANGE_PASSWORD,
  payload: { currentPassword, newPassword, history },
});
export const changePasswordSuccess = () => ({
  type: CHANGE_PASSWORD_SUCCESS,
});
export const changePasswordError = (message) => ({
  type: CHANGE_PASSWORD_ERROR,
  payload: { message },
});

export const registerUser = (user, history) => ({
  type: REGISTER_USER,
  payload: { user, history },
});
export const registerUserSuccess = (user) => ({
  type: REGISTER_USER_SUCCESS,
  payload: user,
});
export const registerUserError = (message) => ({
  type: REGISTER_USER_ERROR,
  payload: { message },
});

export const logoutUser = () => ({
  type: LOGOUT_USER,
});

export const clearAuthFeedback = () => ({
  type: CLEAR_AUTH_FEEDBACK,
});
